import React, {Component} from 'react';
import WizardTableHeader from "./wizardTableHeader";
import WizardTableCell from "./wizardTableCell";

import _ from 'lodash';
import {areEntitiesWithIdsEqual} from "../../../helpers/functions";

const getTableDataStoreIndex = (tableData, subSetting) => {
	return tableData.findIndex(item => {
		try {
			return (
				item.stageId === subSetting.stageId &&
				areEntitiesWithIdsEqual(item.damages, subSetting.damages)
			)
		} catch (e) {
			return false
		}
	});
};

class WizardTable extends Component {

	_renderRows = () => {

		const groupedPerStage = _.groupBy(this.props.tableData, item => item.stageId);

		const sectors = Object.values(groupedPerStage).map((group, groupIndex)=> {
			const sectorRows = [];
			sectorRows.push(
				<tr key={'premium' + groupIndex}>
					<td
						rowSpan={2 + (this.props.solicitorListLength > 0?this.props.solicitorListLength:this.props.solicitorsList.length ) + (this.props.selectedCaseType === 'Clinical Negligence'?2:0)}
						className="premiumSettingsWizard-table-group-of-rows premiumSettingsWizard-table-data premiumSettingsWizard-table-data-border-top premiumSettingsWizard-vertical-label-wrapper"
					>
						<span className="premiumSettingsWizard-vertical-label">{group[0]?group[0].stageName:''}</span>
					</td>
					<td
						className="premiumSettingsWizard-table-data premiumSettingsWizard-table-data-first-column-text"
					>
						{'Premium'}
					</td>
					{group.map((data, index) => {
						const storedTableDataIndex = getTableDataStoreIndex(this.props.tableData, data);
						return (
							<WizardTableCell
								isPlain={this.props.isPlain}
								key={index}
								tableData={this.props.tableData}
								getAgentIndex={this.props.getAgentIndex}
								realIndex={storedTableDataIndex}
								handlePremiumAndUnderwriterChange={this.props.handlePremiumAndUnderwriterChange}
								isPremium={true}
								solicitorsList={this.props.solicitorsList}
							/>
						)

					})
					}
				</tr>
			);
			if(this.props.selectedCaseType === 'Clinical Negligence' ){
				sectorRows.push(
					<tr key={'Clinical Negligence rec' + groupIndex}>
						<td className="premiumSettingsWizard-table-data premiumSettingsWizard-table-data-first-column-text"
						>
							{'Recoverable'}
						</td>
						{group.map((data, index) => {
							const storedTableDataIndex = getTableDataStoreIndex(this.props.tableData, data);
							return (
								<WizardTableCell
									handleRecoverableAndNonRecoverableChange={this.props.handleRecoverableAndNonRecoverableChange}
									isPlain={this.props.isPlain}
									key={index}
									tableData={this.props.tableData}
									getAgentIndex={this.props.getAgentIndex}
									realIndex={storedTableDataIndex}
									handlePremiumAndUnderwriterChange={this.props.handlePremiumAndUnderwriterChange}
									isRecoverable={true}
									isPremium={false}
									isUnderwriter={false}
									caseStage={group.stateName}
									damageBands={this.props.damageBands}
									solicitorsList={this.props.solicitorsList}
								/>
							)

						})
						}
					</tr>
				);
				sectorRows.push(
					<tr key={'Clinical Negligence non rec' + groupIndex}>
						<td className="premiumSettingsWizard-table-data premiumSettingsWizard-table-data-first-column-text"
						>
							{'Non recoverable'}
						</td>
						{group.map((data, index) => {
							const storedTableDataIndex = getTableDataStoreIndex(this.props.tableData, data);
							return (
								<WizardTableCell
									handleRecoverableAndNonRecoverableChange={this.props.handleRecoverableAndNonRecoverableChange}
									isNonRecoverable={true}
									isPlain={this.props.isPlain}
									key={index}
									tableData={this.props.tableData}
									getAgentIndex={this.props.getAgentIndex}
									realIndex={storedTableDataIndex}
									handlePremiumAndUnderwriterChange={this.props.handlePremiumAndUnderwriterChange}
									isPremium={false}
									isUnderwriter={false}
									caseStage={group.stageName}
									damageBands={this.props.damageBands}
									solicitorsList={this.props.solicitorsList}
								/>
							)

						})
						}
					</tr>
				)
			}

			sectorRows.push(
				<tr key={'underwriter' + groupIndex}>
					<td className="premiumSettingsWizard-table-data premiumSettingsWizard-table-data-first-column-text"
					>
						{'Underwriter Rate'}
					</td>
					{group.map((data, index) => {
						const storedTableDataIndex = getTableDataStoreIndex(this.props.tableData, data);
						return (
							<WizardTableCell
								isPlain={this.props.isPlain}
								key={index}
								tableData={this.props.tableData}
								getAgentIndex={this.props.getAgentIndex}
								realIndex={storedTableDataIndex}
								handlePremiumAndUnderwriterChange={this.props.handlePremiumAndUnderwriterChange}
								isPremium={false}
								isUnderwriter={true}
								caseStage={group.stageName}
								damageBands={this.props.damageBands}
								solicitorsList={this.props.solicitorsList}
							/>
						)

					})
					}
				</tr>
			);

			try {
				sectorRows.push(
					group[0].premiumSubSettingCommissions.map((solicitor, index) => {
						let lawsys;
						if(this.props.showTable){
							lawsys = solicitor?solicitor.lawsysName:'';
						} else {
							lawsys = this.props.getSolicitor(solicitor.lawsysId);
							lawsys = lawsys?lawsys.name:''
						}

						return (
							<tr key={index}>
								<td className="premiumSettingsWizard-table-data-first-column-text"
								>
									{lawsys} <br/>{'Commission'}
								</td>
								{
									group.map((data, dataIndex) => {
										const storedTableDataIndex = getTableDataStoreIndex(this.props.tableData, data);
										return (
											<WizardTableCell
												key={dataIndex}
												isPlain={this.props.isPlain}
												handleCommissionChange={this.props.handleCommissionChange}
												solicitorIndex={index}
												tableData={this.props.tableData}
												getAgentIndex={this.props.getAgentIndex}
												realIndex={storedTableDataIndex}
												handlePremiumAndUnderwriterChange={this.props.handlePremiumAndUnderwriterChange}
												isPremium={false}
												isUnderwriter={false}
												caseStage={group.stageName}
												damageBands={this.props.damageBands}
												solicitorsList={this.props.solicitorsList}
											/>
										)
									})
								}
							</tr>
						)
					})
				);
			} catch (e) {

			}

			return (
				<tbody key={groupIndex}>{sectorRows}</tbody>
			)
		});
		return sectors;
	};

	render() {
		return (
			<div className="premiumSettingsWizard-table-wrapper">
				<table className="table table-striped agents-list-table premiumSettingsWizard-table">
					<WizardTableHeader
						getTableHeaderData={this.props.getTableHeaderData}
					/>
					{this._renderRows()}
				</table>
			</div>
		)
	}

}

export default WizardTable;